import { Diagnostic } from "@siteimprove/alfa-act";
import { Array } from "@siteimprove/alfa-array";
/**
 * @public
 */
export class WithBadElements extends Diagnostic {
    static of(message, errors = []) {
        return new WithBadElements(message, Array.from(errors));
    }
    _errors;
    constructor(message, errors) {
        super(message);
        this._errors = errors;
    }
    get errors() {
        return this._errors;
    }
    equals(value) {
        return (value instanceof WithBadElements &&
            value._message === this._message &&
            Array.equals(value._errors, this._errors));
    }
    hash(hash) {
        super.hash(hash);
        this._errors.forEach((element) => element.hash(hash));
    }
    *[Symbol.iterator]() {
        yield* this._errors;
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            errors: Array.toJSON(this._errors, options),
        };
    }
}
/**
 * @public
 */
(function (WithBadElements) {
    function isWithBadElements(value) {
        return value instanceof WithBadElements;
    }
    WithBadElements.isWithBadElements = isWithBadElements;
})(WithBadElements || (WithBadElements = {}));
//# sourceMappingURL=with-bad-elements.js.map